import { IAppGlobalConfig, IServerConfig } from './../app.store.interface';
import { HttpClient } from '@angular/common/http';



export class AppGlobalConfigAction {

  constructor(
    private getState: () => IAppGlobalConfig,
    private setState: (newState: IAppGlobalConfig) => void,
    private http: HttpClient) {
  }

  setLoading = (show: boolean) => {
    this.setState({ ...this.getState(), isLoading: show });
  }

  //=======================================================
  //actions que mutan el estado
  //=======================================================

  getGlobalBegin = () => {
    this.setState({ ...this.getState(), isLoading: true, error: false });
  };

  getGlobalConfigSuccess = (configuration: IServerConfig) => {
    this.setState({ ...this.getState(), isLoading: false, error: false, configuration: configuration });
  };

  getGlobalConfigError = () => {
    this.setState({ ...this.getState(), isLoading: false, error: true });
  };

  //=======================================================
  //actions que obtienen data del estado
  //=======================================================

  // buildUrlLoginPunku = (currentUrl: string): string => {
  //   const { punku } = this.getState().configuration;
  //   const url = punku.api.loginUrl
  //     .replace('{0}', punku.guidSistema)
  //     .replace('{1}', punku.returnUrl)
  //     .replace('{2}', (currentUrl ? encodeURIComponent(`returnUrl=${currentUrl}`) : ''));
  //   return url;
  // }

  // buildUrlChangePasswordPunku = (token: string) => {
  //   const { punku } = this.getState().configuration;
  //   const url = punku.api.changePasswordUrl
  //     .replace('{0}', token)
  //     .replace('{1}', punku.returnUrl);
  //   return url;
  // }

  //=======================================================
  //async actions
  //=======================================================

  asyncGetGlobalConfig = () => {
    this.getGlobalBegin();
    return new Promise((resolve, reject) => {
      this.http.get<IServerConfig>('/api/Configuration/ConfigurationData').subscribe(config => {
        setTimeout(() => {
          this.getGlobalConfigSuccess(config);
          resolve();
        });
      }, error => {
        setTimeout(() => {
          this.getGlobalConfigError();
          reject();
          /*const config = {
            gateway: {
              academico: "https://localhost:44304"
            },
            punku: {
              guid: "01E002E4-2794-45AB-A9E3-94FEAC502550",
              returnUrl: "http://localhost:4200/logging-in",
              api: {
                proxyUrl: "https://auth-proxy.sunedu.gob.pe:4435",
                loginUrl: "https://auth-app.sunedu.gob.pe:4438/Home/Login?userSystemId={0}&returnUrl={1}&extra={2}",
                logoutUrl: "https://auth-app.sunedu.gob.pe:4438/Home/Logout?token={0}&returnUrl={1}",
                changePasswordUrl: "https://auth-app.sunedu.gob.pe:4438/Home/ChangePassword?token={0}&returnUrl={1}"
              }
            }
          }*/
          //this.getGlobalConfigSuccess(config);
        });
      });
    });

  }

}
